module.exports = __webpack_public_path__ + "img/阿隆戴特的狂潮.8eda775f.webp";